import React from 'react';
import PropTypes from 'prop-types';
import { BACKGROUND_COLOR } from '../colors';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * Panels: this component shows a container with several panels.
 * parameters
 * @param arrayOf(nodes) panels
 * @param mode string
 * @param showColumnDirection bool => if this values is true then the panels
 *   will display in column direction
 *
 * Notice: each panel should be a component that use the component Panel
 */
export default class Panels extends React.PureComponent {
  render() {
    const { panels, mode, showColumnDirection } = this.props;
    const styleContainerWrapper = {
      paddingTop: '1.5rem',
      backgroundColor: BACKGROUND_COLOR,
    };
    const stylePanel = {};

    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      styleContainerWrapper.backgroundColor = modeColors.BACKGROUND_COLOR;
    }
    let classNamePanelWrapper = 'panel-wrapper';
    if (showColumnDirection) {
      classNamePanelWrapper = 'panel-wrapper column';
    }
    return (
      <div style={styleContainerWrapper} className={classNamePanelWrapper}>
        {panels.map((Panel, index) => (
          <div className="panel-item" style={stylePanel} key={index.toString()}>
            <Panel />
          </div>
        ))}
      </div>
    );
  }
}

Panels.propTypes = {
  panels: PropTypes.arrayOf(Object).isRequired,
  mode: PropTypes.string,
  showColumnDirection: PropTypes.bool,
};

Panels.defaultProps = {
  mode: null,
  showColumnDirection: false,
};
